var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import { signInStart, signInSucceeded, signInFailed, signInAutomaticallyStart, signInAutomaticallySucceeded, signInAutomaticallyFailed, ssoSignInStart, ssoSignInSucceeded, ssoSignInFailed, setSelectedDashboardStart, setAccessTokensWithoutSideEffectsStart, refreshSuccessStart, refreshSuccessSucceeded, signOutStart, signUpStart, signUpSucceeded, signUpFailed, signUpVerifyPhoneStart, signUpVerifyPhoneSucceeded, signUpVerifyPhoneFailed, getUserStart, getUserSucceeded, getUserFailed, updateUserStart, updateUserSucceeded, updateUserFailed, updateUserByIdStart, updateUserByIdSucceeded, updateUserByIdFailed, adminVerifyEmailStart, adminVerifyEmailSucceeded, adminVerifyEmailFailed, adminVerifyPhoneStart, adminVerifyPhoneSucceeded, adminVerifyPhoneFailed, removeProfileStart, removeProfileSucceeded, removeProfileFailed, } from "./auth.actions";
var getDefaultState = function () { return ({
    isSigningIn: false,
    signInError: undefined,
    isSigningInAutomatically: false,
    signInAutomaticallyError: undefined,
    isSigningInWithSso: false,
    ssoSignInError: undefined,
    isSigningUp: false,
    signUpError: undefined,
    isSignUpVerifyingPhone: false,
    signUpVerifyPhoneError: undefined,
    user: undefined,
    isFetchingUser: false,
    fetchUserError: undefined,
    isUpdatingUser: false,
    updateUserError: undefined,
    isAdminVerifyingEmailOrPhone: false,
    adminVerifyError: undefined,
    isRemovingProfile: false,
    removeProfileError: undefined,
    updateUserById: {},
    selectedDashboardType: undefined,
    refetch: false,
}); };
var reducer = createReducer({}, getDefaultState());
reducer.on(signOutStart.type, function () {
    return __assign({ hasAccessToken: false }, getDefaultState());
});
reducer.on(signInStart.type, function (state, _) {
    return __assign(__assign({}, state), { isSigningIn: true, signInError: undefined });
});
reducer.on(signInSucceeded.type, function (state, _a) {
    var selectedDashboardType = _a.selectedDashboardType;
    return __assign(__assign({}, state), { hasAccessToken: true, isSigningIn: false, signInError: undefined, selectedDashboardType: selectedDashboardType });
});
reducer.on(signInFailed.type, function (state, _a) {
    var error = _a.error;
    return __assign(__assign({}, state), { isSigningIn: false, signInError: error });
});
reducer.on(signInAutomaticallyStart.type, function (state, _) {
    return __assign(__assign({}, state), { hasAccessToken: false, user: undefined, isSigningInAutomatically: true, signInAutomaticallyError: undefined });
});
reducer.on(signInAutomaticallySucceeded.type, function (state, _a) {
    var selectedDashboardType = _a.selectedDashboardType;
    return __assign(__assign({}, state), { hasAccessToken: true, isSigningInAutomatically: false, signInAutomaticallyError: undefined, selectedDashboardType: selectedDashboardType });
});
reducer.on(signInAutomaticallyFailed.type, function (state, _a) {
    var error = _a.error;
    return __assign(__assign({}, state), { isSigningInAutomatically: false, signInAutomaticallyError: error });
});
reducer.on(ssoSignInStart.type, function (state, _) {
    return __assign(__assign({}, state), { hasAccessToken: false, user: undefined, isSigningInWithSso: true, ssoSignInError: undefined });
});
reducer.on(ssoSignInSucceeded.type, function (state, _a) {
    var selectedDashboardType = _a.selectedDashboardType;
    return __assign(__assign({}, state), { hasAccessToken: true, isSigningInWithSso: false, ssoSignInError: undefined, selectedDashboardType: selectedDashboardType });
});
reducer.on(ssoSignInFailed.type, function (state, _a) {
    var error = _a.error;
    return __assign(__assign({}, state), { 
        // Also reached after ssoSignInSucceeded, when storing the tokens failed. Left true, the
        // SSO sign-in page the person is sent back to would read them as signed in and bounce
        // them on to a dashboard without a session.
        hasAccessToken: false, isSigningInWithSso: false, ssoSignInError: error });
});
reducer.on(setSelectedDashboardStart.type, function (state, _a) {
    var dashboardType = _a.dashboardType;
    return __assign(__assign({}, state), { selectedDashboardType: dashboardType });
});
reducer.on(setAccessTokensWithoutSideEffectsStart.type, function (state, _) {
    return __assign(__assign({}, state), { hasAccessToken: true });
});
reducer.on(getUserStart.type, function (state) { return (__assign(__assign({}, state), { isFetchingUser: true, fetchUserError: undefined })); });
reducer.on(getUserSucceeded.type, function (state, user) {
    if (!user.tac) {
        // eslint-disable-next-line no-console
        console.log("Get user success - User has no tac object", { user: user });
    }
    return __assign(__assign({}, state), { user: user, isFetchingUser: false, fetchUserError: undefined });
});
reducer.on(getUserFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isFetchingUser: false, fetchUserError: error }));
});
reducer.on(refreshSuccessStart.type, function (state, _) { return (__assign(__assign({}, state), { refetch: false })); });
reducer.on(refreshSuccessSucceeded.type, function (state, _) { return (__assign(__assign({}, state), { refetch: true })); });
reducer.on(signUpStart.type, function (state) { return (__assign(__assign({}, state), { isSigningUp: true, signUpError: undefined })); });
reducer.on(signUpSucceeded.type, function (state, _a) {
    var user = _a.user;
    return (__assign(__assign({}, state), { user: user, isSigningUp: false, signUpError: undefined }));
});
reducer.on(signUpFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isSigningUp: false, signUpError: error }));
});
reducer.on(signUpVerifyPhoneStart.type, function (state) { return (__assign(__assign({}, state), { isSignUpVerifyingPhone: true, signUpVerifyPhoneError: undefined })); });
reducer.on(signUpVerifyPhoneSucceeded.type, function (state) { return (__assign(__assign({}, state), { hasAccessToken: true, isSignUpVerifyingPhone: false, signUpVerifyPhoneError: undefined })); });
reducer.on(signUpVerifyPhoneFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isSignUpVerifyingPhone: false, signUpVerifyPhoneError: error }));
});
reducer.on(updateUserStart.type, function (state) { return (__assign(__assign({}, state), { isUpdatingUser: true, updateUserError: undefined })); });
reducer.on(updateUserSucceeded.type, function (state, _a) {
    var user = _a.user;
    return (__assign(__assign({}, state), { user: user, isUpdatingUser: false, updateUserError: undefined }));
});
reducer.on(updateUserFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isUpdatingUser: false, updateUserError: error }));
});
reducer.on(updateUserByIdStart.type, function (state, _a) {
    var _b;
    var id = _a.id;
    return (__assign(__assign({}, state), { updateUserById: __assign(__assign({}, state.updateUserById), (_b = {}, _b[id] = {
            user: undefined,
            isFetching: true,
            fetchError: undefined,
        }, _b)) }));
});
reducer.on(updateUserByIdSucceeded.type, function (state, _a) {
    var _b;
    var id = _a.id, user = _a.user;
    return (__assign(__assign({}, state), { updateUserById: __assign(__assign({}, state.updateUserById), (_b = {}, _b[id] = {
            user: user,
            isFetching: false,
            fetchError: undefined,
        }, _b)) }));
});
reducer.on(updateUserByIdFailed.type, function (state, _a) {
    var _b;
    var id = _a.id, error = _a.error;
    return (__assign(__assign({}, state), { updateUserById: __assign(__assign({}, state.updateUserById), (_b = {}, _b[id] = {
            user: undefined,
            isFetching: false,
            fetchError: error,
        }, _b)) }));
});
reducer.on(adminVerifyEmailStart.type, function (state) { return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: true, adminVerifyError: undefined })); });
reducer.on(adminVerifyEmailSucceeded.type, function (state) { return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: false, adminVerifyError: undefined })); });
reducer.on(adminVerifyEmailFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: false, adminVerifyError: error }));
});
reducer.on(adminVerifyPhoneStart.type, function (state) { return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: true, adminVerifyError: undefined })); });
reducer.on(adminVerifyPhoneSucceeded.type, function (state) { return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: false, adminVerifyError: undefined })); });
reducer.on(adminVerifyPhoneFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: false, adminVerifyError: error }));
});
reducer.on(removeProfileStart.type, function (state) { return (__assign(__assign({}, state), { isRemovingProfile: true, removeProfileError: undefined })); });
reducer.on(removeProfileSucceeded.type, function (state, _a) {
    var user = _a.user;
    return (__assign(__assign({}, state), { user: user, isRemovingProfile: false, removeProfileError: undefined }));
});
reducer.on(removeProfileFailed.type, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isRemovingProfile: false, removeProfileError: error }));
});
// eslint-disable-next-line import/no-default-export
export default reducer;
